import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { Elaboration } from 'app/shared/models/elaboration.model';
import { ElaborationService } from 'app/entities/monitoring/actual/elaboration/elaboration.service';

@Component({
  templateUrl: './update-elaboration.component.html',
  providers: [ElaborationService],
})

/**
 * Dialog component to update monitoring Elaboration description through editor.
 */
export class UpdateElaborationComponent implements OnInit {
  elaborationEditorForm: FormGroup;
  argElaborationDetailsData: string;
  argId: number;
  entityTypeId: number;
  argEntityType: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private elaborationService: ElaborationService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.updateElaborationDataForm();
  }

  buildForm() {
    this.elaborationEditorForm = this.formBuilder.group({
      elaborationText: [{ value: "" }],
    });
  }

  // Method to update elaboration description and display in the card.
  updateElaborationDataForm(): void {
    if (this.argElaborationDetailsData) {
      this.elaborationEditorForm.patchValue({
        elaborationText: this.argElaborationDetailsData,
      });
    }
  }

  // Method to submit the changes for elaboration description text.
  onSubmit({ value, valid }) {
    this.elaborationEditorForm.disable();
    const elaborationModel = new Elaboration();
    elaborationModel.description = value.elaborationText;

    this.elaborationService.updateElaborationDescription(elaborationModel, this.argId)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(elaborationModel);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.MONITORING_ELABORATION_TEXT_UPDATE,
          TrackingConstants.PERFORM_MONITORING_ELABORATION_TEXT_UPDATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
          this.trackingService
            .emitEvent(
            TrackingConstants.MONITORING_ELABORATION_TEXT_UPDATE,
            TrackingConstants.PERFORM_MONITORING_ELABORATION_TEXT_UPDATE,
            TrackingConstants.FAILURE, 0);
          this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.MONITORING_ELABORATION_TEXT_UPDATE_SUCCESS,
      MessageService.MONITORING_ELABORATION_TEXT_UPDATE_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.elaborationEditorForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/elaboration/updateelaboration/update-elaboration.component.ts